"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { cn } from '../helpers/cn.mjs';
import { withSlotScopeClasses } from '../helpers/scoped-slots.mjs';

const rawClasses = {
  "popover-container": cn(
    "outline-none",
    "focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-0 focus-visible:outline-blue-10",
    "flex overflow-hidden bg-bg-default shadow-xl rounded-lg",
    "border-border-subtle border-[0.5px]",
    "p-0 max-w-none max-h-[var(--available-height)] h-full w-fit"
  ),
  content: "flex flex-col p-1.5 w-full min-w-56 max-w-[min(65em,90vw)] max-h-[inherit]",
  panel: "flex flex-col overflow-hidden pb-1.5 min-h-8 last:pb-0",
  "search-input": cn(
    "w-full flex-1 rounded-none border-0 px-2 py-1.5",
    "text-base leading-6 font-medium",
    "placeholder-shown:truncate",
    "focus:shadow-none"
  ),
  "search-divider": "pt-0.5 pb-1.5 border-0 border-t border-border-subtle",
  list: cn(
    "overflow-y-auto relative grow min-h-8 max-w-md",
    "[&:has(>[data-virtualized-list=true]:only-child)]:grid",
    "[&:has(>[data-virtualized-list=true]:only-child)]:flex-col"
  ),
  item: cn(
    "flex flex-row gap-1.5 items-center px-2 py-1 cursor-pointer min-h-6 rounded-md",
    "hover:bg-bg-muted",
    "data-[current]:bg-bg-muted"
  ),
  "no-options-heading": cn(
    "flex flex-row gap-1.5 items-center px-2 py-1 min-h-6 max-w-md",
    "text-fg-muted border-border-subtle border",
    "font-medium text-sm leading-5 rounded-lg bg-bg-subtle"
  ),
  "no-options-heading-icon": "text-fg-default h-4 w-4",
  "error-heading": "flex flex-row gap-1.5 items-center px-2 py-1 min-h-6 font-medium text-sm leading-5",
  "error-heading-icon": "text-tomato-10 h-7 w-7",
  "info-heading": "flex flex-row gap-1.5 items-center px-2 py-1 min-h-6 font-medium text-sm leading-5",
  "info-heading-icon": "text-fg-default h-7 w-7",
  "loading-item-container": "flex flex-row gap-1.5 items-center px-2 py-1",
  "loading-item-icon": "h-6 w-6 rounded-md",
  "loading-item-title": "h-5 w-3/5 rounded-md",
  "items-list-header": cn(
    "flex p-2 text-fg-muted uppercase text-xs font-medium tracking-wide",
    "sticky top-0 z-docked min-h-[auto] pointer-events-none bg-bg-default"
  ),
  "item-title": "grow max-w-full min-w-1/2 break-words text-sm leading-5 font-medium",
  "item-hint": "text-fg-disabled text-xs leading-[1.125rem] min-w-1/6 max-w-2/5 text-right mt-0.5"
};
const dropdownClasses = Object.fromEntries(
  Object.entries(withSlotScopeClasses("dropdown", rawClasses)).map(([slot, parts]) => [slot, parts.join(" ")])
);
const dropdownRecipe = (_props) => dropdownClasses;

export { dropdownRecipe };
